export const serverErrorFallbackText =
  "Something went wrong and LawWorks has been notified. If the error persists after refreshing your page, please try again later. We apologize for the inconvenience.";
